import * as THREE from 'three'

import { RGBAFormat } from 'three'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js'

import EventEmitter from "./EventEmitter"

const BASE_URL = "https://www.openeconomics.eu/";

export default class Resources extends EventEmitter
{
    constructor(sources)
    {
        super()

        this.sources = sources
        
        this.items = {}

        this.toLoad = 0
        this.loaded = 0
        
        this.loadingManager = new THREE.LoadingManager()
        this.progressBar = document.querySelector('#progress-bar .pct')
        this.progressBarContainer = document.querySelector('.progress-bar-container')
        this.progressBarContainer.style.opacity = 1

        this.waitTime = 0.5

        this.loadingManager.onProgress = (url, loaded, total) => {
            let pct =  (100.0 * loaded / total);
            this.progressBar.style.width = pct + '%';
        }

        this.version = "assets-nh"

        this.setLoaders()
        this.startLoading()
    }

    initSources(source)
    {
        this.toLoad++
        if (process.env.NODE_ENV == "production")
        {
            if (Array.isArray(source.path)) source.path = source.path.map(path => path = BASE_URL + this.version + path)
            else source.path = BASE_URL + this.version + source.path
        }
    }

    loadSource(source)
    {
        if (source.type ===  'gltfModel') this.loaders.gltfLoader.load(source.path, (file) => {this.sourceLoaded(source, file)})
        else if (source.type ===  'texture') this.loaders.textureLoader.load(source.path, (file) => {this.sourceLoaded(source, file)})
        else if (source.type ===  'cubeTexture') this.loaders.cubeTextureLoader.load(source.path, (file) => {this.sourceLoaded(source, file)})
        else if (source.type === 'audio') this.loaders.audioLoader.load(source.path, (file) => {this.sourceLoaded(source, file)})
    }

    setLoaders()
    {
        this.loaders = {}
        this.loaders.gltfLoader = new GLTFLoader(this.loadingManager)
        this.loaders.textureLoader = new THREE.TextureLoader(this.loadingManager)
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader(this.loadingManager)
        this.loaders.audioLoader = new THREE.AudioLoader(this.loadingManager)

        this.dracoLoader = new DRACOLoader()

        if (process.env.NODE_ENV == "development") this.dracoLoader.setDecoderPath("/draco/gltf/")
        else if (process.env.NODE_ENV == "production") this.dracoLoader.setDecoderPath(BASE_URL + this.version + "/draco/gltf/")

        this.loaders.gltfLoader.setDRACOLoader(this.dracoLoader)

        this.sources.forEach(source => {source.forEach(element => {this.initSources(element)})})
    }

    startLoading()
    {
        this.sources.forEach(source => {source.forEach(element => {this.loadSource(element)})})
    }

    sourceLoaded(source, file)
    {
        this.items[source.name] = file

        this.loaded++

        if (this.loaded === this.toLoad)
        {
            this.trigger('ready')
        }
    }

    exitLoader()
    {
        var tl = gsap.timeline();
        tl.set("#progress-bar", {backgroundColor: 'transparent', delay: .25});
        tl.set("#progress-bar .pct", {left: 'auto', right: 0});
        tl.to("#progress-bar .pct", {width: 0, duration: .1});
        tl.to(".icon", {opacity:0, duration: .25, delay: .75});
        tl.to(".progress-bar-container", {opacity:0, duration: .75, delay: .25});
        tl.set(".progress-bar-container", { display:'none'});
        this.doFadeOut = false;
        this.trigger('fade out');
    }
}